import { render, staticRenderFns } from "./CustomerCarFormV2.vue?vue&type=template&id=5d86de8c"
import script from "./CustomerCarFormV2.vue?vue&type=script&lang=js"
export * from "./CustomerCarFormV2.vue?vue&type=script&lang=js"
import style0 from "./CustomerCarFormV2.vue?vue&type=style&index=0&id=5d86de8c&prod&lang=scss"


/* normalize component */
import normalizer from "!./node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports